import { Database } from '../db.ts';
import { PremiumLevel } from './premium.ts';

type DBProduct = Database['public']['Tables']['products']['Row'];

export type ProductData = Omit<DBProduct, 'availability_level' | 'prices' | 'meta' | 'type'> & {
    availability_level: PremiumLevel;
    prices: ProductPrices | null;
    meta: ProductMeta | null;
    type: ProductTypes;
};

export type ProductPrices = {
    current: string,
    origin?: string,

    numeric: {
        current: number,
        /** iso format, 'usd' is default */
        currency?: string,
    },
};

export type ProductReachDiapason = {
    min: number,
    max: number,
};

export type ProductPoint = {
    status: boolean,
    value: string,
};

export type ProductMeta = {
    guaranteedStream: number,
    maxStreamPotential: number,
    reachDiapason: ProductReachDiapason,
    points: ProductPoint[],
    mostPopular: boolean,
    color: string,
    daysRange: number[],
};

export enum ProductTypes {
    Spotify = 'spotify',
}
